import mitt, { Emitter } from "mitt";

const emitter= mitt();

// 导出
export default emitter;
